import { render, staticRenderFns } from "./DestinationOptionCard.vue?vue&type=template&id=a8ebbb52&scoped=true"
import script from "./DestinationOptionCard.vue?vue&type=script&lang=js"
export * from "./DestinationOptionCard.vue?vue&type=script&lang=js"
import style0 from "./DestinationOptionCard.vue?vue&type=style&index=0&id=a8ebbb52&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ebbb52",
  null
  
)

export default component.exports